import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
export function PaidTotalCallout() {
  return <div role="note" className="flex items-start gap-2 rounded border border-[#91DB8B] bg-sf-green-light px-3 py-2 text-xs text-sf-text" data-id="element-391" data-mp="30yku360s75oo">
      <CircleCheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-sf-green" aria-hidden="true" data-id="element-392" data-mp="2w6t7f6kqxk3t" />
      <p data-id="element-393" data-mp="2r8rqar6vruuz">
        <strong data-id="element-394" data-mp="2r91a1x1c15s8">Pay basis: Adjusted amount (Adjusted Loan Amount × BPS).</strong> Stored (unadjusted) is shown for reference only.
      </p>
    </div>;
}